import gql from 'graphql-tag';





const createVideoPublicLinkMutation = gql`
  mutation createVideoPublicLink($videoId: String!, $input: VideoPublicLinkInput!) {
    createVideoPublicLink(videoId: $videoId, input: $input) {
      videoId
      link
      expiryDate
    }
  }
`;

const createVideoPublicLink = () => ({
  mutation: createVideoPublicLinkMutation,
  module: 'video',
  buildVariables: ({ videoId, input


  }) => ({
    videoId,
    input
  })
});

export default createVideoPublicLink;